import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const rootModule = {
  state() {
    return {
      authInformation: Object,
      clientInformation: Object,
      isShowLoader: false,
      sessionId: "",
      isClientInformationLoad: false,
      showNotification: false,
      notificationMessage: Object,
      engagementData: Object,
      notificationSummary: Object,
      jwtToken: Object,
      riskprofiledata: Array,
    };
  },
  mutations,
  actions,
  getters,
};

export default rootModule;
